import {ValidationError} from '../../models/validation-error.model';
import {CoAcquisition} from '../../models/co-acquisition.model';
import {SearchQueryParams} from '../../models/search-query-params.model';

export namespace CoAcquisitionActions {
    export class GetListPage {
        static readonly type = 'CoAcquisition.GetListPage';

        constructor(public params?: SearchQueryParams) {
        }
    }

    export class GetById {
        static readonly type = 'CoAcquisition.GetById';

        constructor(public id: number) {
        }
    }

    export class Add {
        static readonly type = 'CoAcquisition.Add';

        constructor(public readonly coAcquisition: CoAcquisition) {
        }
    }

    export class Update {
        static readonly type = 'CoAcquisition.Update';

        constructor(public readonly coAcquisition: CoAcquisition) {
        }
    }

    export class Delete {
        static readonly type = 'CoAcquisition.Delete';

        constructor(public readonly id: string) {}
    }

    export class FormFailure {
        static readonly type = 'CoAcquisition.FormFailure';

        constructor(public readonly validationErrors: ValidationError[]) {
        }
    }
}
